import moment from "moment";
import BaseComponent from "../../baseComponent.js";
import styles from "./month-picker.scss";

export default class MonthPicker extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: this.props.selected,
      currentShowingDate: this.props.selected,
      showNext: this.getToTalMonths(this.props.selected) < this.getToTalMonths(this.props.maxDate),
      showPrev: this.getToTalMonths(this.props.selected) > this.getToTalMonths(this.props.minDate)
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentDate: nextProps.selected,
      currentShowingDate: nextProps.selected,
      showNext: this.getToTalMonths(nextProps.selected) < this.getToTalMonths(nextProps.maxDate),
      showPrev: this.getToTalMonths(nextProps.selected) > this.getToTalMonths(nextProps.minDate)
    });
  }

  getToTalMonths(date) {
    return date.get("year") * 12;
  }

  handleChange(type) {
    var _this = this;
    return function (date) {
      _this.props.onDateFilterChange(type, date);
    }
  }

  showPicker() {
    $(this.refs.picker).show();
  }

  hidePicker(event) {
    $(this.refs.picker).hide();
    this.setState({
      currentShowingDate: this.state.currentDate
    });
  }

  moveNextYear(event) {
    event.preventDefault();
    const copy = this.state.currentShowingDate.toDate();
    this.updateState(moment(copy).add(1, "y"));
  }

  movePrevYear(event) {
    event.preventDefault();
    const copy = this.state.currentShowingDate.toDate();
    this.updateState(moment(copy).add(-1, "y"));
  }

  updateState(currentShowingDate) {
    this.setState({
      currentShowingDate: currentShowingDate,
      showNext: this.getToTalMonths(currentShowingDate) < this.getToTalMonths(this.props.maxDate),
      showPrev: this.getToTalMonths(currentShowingDate) > this.getToTalMonths(this.props.minDate)
    });
  }

  handleMouseDown(event) {
    event.preventDefault();
  }

  changeDate(month) {
    var _this = this;
    return function (event) {
      if ($(event.target).hasClass("month-picker--disabled")) return;
      var year = _this.state.currentShowingDate.get("year");
      var selectedDate = moment(year + "-" + (month + 1) + "-" + "1");
      if (_this.props.type === "end") {
        selectedDate.endOf("month").endOf("day");
      }
      _this.props.onChange(selectedDate);
      _this.hidePicker();
    }
  }

  render() {
    var months = ["Jan", "Feb", "Mar", "Apr",
      "May", "June", "July", "Aug",
      "Sept", "Oct", "Nov", "Dec"];

    var monthElements = [];
    var nextBtn = null, prevBtn = null;
    var totalMonthsOfMinDate = this.props.minDate.get("year") * 12 + this.props.minDate.get("month");
    var totalMonthsOfMaxDate = this.props.maxDate.get("year") * 12 + this.props.maxDate.get("month");
    for (var i = 0; i < months.length; i++) {
      var totalMonths = this.state.currentShowingDate.get("year") * 12 + i;
      var selectable = totalMonths >= totalMonthsOfMinDate && totalMonths <= totalMonthsOfMaxDate;
      var classes = "";
      classes += selectable ? "" : " month-picker--disabled";

      if (this.state.currentDate.get("year") === this.state.currentShowingDate.get("year")) {
        if (this.props.selected.month() === i) {
          classes = "month-picker--selected"
        }
      }

      monthElements.push(<div className={classes} key={i} onClick={this.changeDate(i)}>{months[i]}</div>);
    }

    if (this.state.showNext) {
      nextBtn = <a className="react-datepicker__navigation react-datepicker__navigation--next"
                   onMouseDown={this.moveNextYear}/>;
    }

    if (this.state.showPrev) {
      prevBtn = <a className="react-datepicker__navigation react-datepicker__navigation--previous"
                   onMouseDown={this.movePrevYear}/>;
    }

    var displayValue = this.props.selected.format("MMM YYYY");

    return (
      <div className="input-field month-picker">
        <input type="text" value={displayValue}
               onBlur={this.hidePicker}
               onClick={this.showPicker}/>
        <div className="month-picker__picker" ref="picker" onMouseDown={this.handleMouseDown}>
          <div className="month-picker__header">
            <div>{this.state.currentShowingDate.get("year")}</div>
            {prevBtn}
            {nextBtn}
          </div>
          <div className="month-picker__months">
            {monthElements}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/common/monthPicker.jsx